import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import MapSetting from "./map/MapSetting.jsx";
import SourceSetting from "./source/SourceSetting.jsx";
import LayerSetting from "./layer/LayerSetting.jsx";
import AnimationSetting from "./animation/AnimationSetting.jsx";
import { DND_LAYER_FIELD } from "./layer/layer_const.js";
import { DND_ANIMATION_FIELD } from "./animation/animation_const.js";
import { DND_SOURCE_FIELD } from "./source/source_const.jsx";
import MapVisualisationWidgetSettingsOption from "./MapVisualisationWidgetSettingsOption.jsx";

const DND_MAP_FIELD = 'general-map-setting-row'

function MapVisualisationWidgetSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const mapFields = useSelector(state => state.dashboard.widgets[widgetId].settings?.mapFields) || [];
    const sourceFields = useSelector(state => state.dashboard.widgets[widgetId].settings?.sourceFields) || [];
    const layerFields = useSelector(state => state.dashboard.widgets[widgetId].settings?.layerFields) || [];
    const animationFields = useSelector(state => state.dashboard.widgets[widgetId].settings?.animationFields) || [];

    useEffect(() => {
        if (mapFields.length === 0){
            setAttribute('settings.mapFields', [{
                id: StringHelper.random(8),
                zoom: 5,
                style: "mapbox://styles/mapbox/streets-v12",
                projection: "globe",
                custom_style: false,
                title: I18n.t('map_settings')
            }])
        }
    }, [mapFields])
    const addSourceFields = () => {
        let newSourceFields = [...sourceFields,{
            id: StringHelper.random(8),
            field_label: "",
            type: "geojson",
            advancedSetting: ""
        }];
        setAttribute('settings.sourceFields', newSourceFields)
    }

    const addLayerFields = () => {
        const newLayerFields = [...layerFields, {
            id: StringHelper.random(8),
            type: "symbol",
            source: "",
            layerDefault: false,
            layerGroup: "",
            layerVisibility: true,
            advancedSetting: ""
        }]
        setAttribute('settings.layerFields', newLayerFields)
    }

    const addAnimationFields = () => {
        const newAnimationFields = [...animationFields, {
        id: StringHelper.random(8),
        type: 'flyTo',
        advancedSetting: ""
        }];
        setAttribute('settings.animationFields', newAnimationFields)
    }

    return (
        <div>
            <MapVisualisationWidgetSettingsOption 
                title={I18n.t('map_settings')} 
                description={I18n.t('mapbox_section_map')} 
                SettingComponent={MapSetting} 
                fields={mapFields} 
                fieldName='mapFields'
                dnd_item_type={DND_MAP_FIELD}
                optionName='title'
                widgetId={widgetId}  />
            <MapVisualisationWidgetSettingsOption 
                title={I18n.t('source')} 
                description={I18n.t('mapbox_section_sources')} 
                SettingComponent={SourceSetting} 
                fields={sourceFields} 
                fieldName='sourceFields' 
                addSetting={() => addSourceFields()}
                dnd_item_type={DND_SOURCE_FIELD}
                optionName='field_label'
                widgetId={widgetId} />
            <MapVisualisationWidgetSettingsOption 
                title={I18n.t('layer')} 
                description={I18n.t('mapbox_section_layers')} 
                SettingComponent={LayerSetting} 
                fields={layerFields} 
                fieldName='layerFields' 
                addSetting={() => addLayerFields()}
                dnd_item_type={DND_LAYER_FIELD}
                optionName='layerName'
                widgetId={widgetId}  /> 
            <MapVisualisationWidgetSettingsOption 
                title={I18n.t('animation')} 
                description={I18n.t('mapbox_section_animation')} 
                SettingComponent={AnimationSetting} 
                fields={animationFields} 
                fieldName='animationFields' 
                addSetting={() => addAnimationFields()}
                dnd_item_type={DND_ANIMATION_FIELD}
                optionName='animationName'
                widgetId={widgetId}  /> 
        </div>
    )
}

export default MapVisualisationWidgetSettings;
